<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0">
        <div class="input-title">Return VXML</div>
        <v-textarea
          v-model="property.vxml"
          class="textarea-input overflow-x m-t-10"
          placeholder="VXML tag"
          solo
          hide-details
          rows="3"
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        ></v-textarea>
        <!-- === use for Intellisense ===-->
        <intellisense-component
          :input="property.vxml"
          :drawFlowItems="drawFlowItems"
          :property="'vxml'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          :eventKey="eventKey"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
    </v-row>
    <hr class="note-divider" />
    <note-component :node="node" :rows="6" />
  </div>
</template>

<script>
import NoteComponent from '../../../components/note'
// === use for Intellisense ===
import IntellisenseComponent from '../../../components/intellisense'
// === use for Intellisense ===
export default {
  props: {
    node: Object,
    // === use for Intellisense ===
    drawFlowItems: Object,
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  components: {
    NoteComponent,
    // === use for Intellisense ===
    IntellisenseComponent
    // === use for Intellisense ===
  },
  data() {
    return {
      property: {},
      // === use for Intellisense ให้ keyup keyDown ได้ ===
      start: -1,
      enterIntellisense: 0,
      isKeyTab: false,
      eventKey: ''
      // === use for Intellisense ให้ keyup keyDown ได้ ===
    }
  },
  created() {
    this.property = this.node.property || {}
  },
  // === use for Intellisense ให้ keyup keyDown ได้ ===
  methods: {
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter(e) {
      if (e.keyCode === 13 && this.start > -1) {
        this.eventKey = 'enter'
        this.start = -1
        e.preventDefault()
      }
      this.eventKey = 'enter'
      this.start = -1
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      this.property.vxml = data
    }
  }
  // === use for Intellisense ให้ keyup keyDown ได้ ===
}
</script>
